export default __webpack_public_path__ + "static/media/CARDIOVASCOLARE_ICONA11.d34ed36a.svg";